import dayjs from 'dayjs';

// Local Redux
import {
	SET_IS_SERVER_ONLINE,
	SET_ACTIVE_ORDERS,
	SET_IS_FETCHING_ACTIVE_ORDER,
	SET_HISTORY_DATE,
	SET_HISTORY_ORDERS,
	SET_IS_FETCHING_HISTORY_ORDER,
	SET_ORDER_DRAWER_DATA,
	CLEAR_ORDER_DRAWER_DATA,
	SET_PLATFORMS,
	SET_BRANDS,
	SET_SYNCING_SAPU_SAPU,
	SET_CONNECTED_TO_SERVER,
	SET_SCHEDULED_ORDERS,
} from '../actionTypes';


const initialState = {
	isServerOnline: null,
	activeOrders: [],
	isFetchingActiveOrder: false,
	historyDate: dayjs().startOf('day').subtract(dayjs().hour() < 7 ? 1 : 0, 'day').toDate(),
	historyOrders: [],
	scheduledOrders: [],
	isFetchingHistoryOrder: false,
	drawer: {
		open: false,
		isDualData: false,
		data: {},
		onSubmitManualProcess: null,
		submitManualLoading: false,
		manualType: '',
		isRecon: false,
		pairSuggestion: null,
	},
	platforms: [],
	brands: [],
	syncingSapuSapu: false,
};

const reducerOrder = (state = initialState, {type, data}) => {
	switch (type) {
		case SET_IS_SERVER_ONLINE:
			return {...state, isServerOnline: data};
		case SET_CONNECTED_TO_SERVER: {
			return {...state, connectedToServer: data.connected};
		}
		case SET_ACTIVE_ORDERS:
	  return {...state, activeOrders: data};
		case SET_IS_FETCHING_ACTIVE_ORDER:
			return {...state, isFetchingActiveOrder: data};
		case SET_HISTORY_DATE:
	  return {...state, historyDate: data};
		case SET_HISTORY_ORDERS:
	  return {...state, historyOrders: data};
		case SET_IS_FETCHING_HISTORY_ORDER:
			return {...state, isFetchingHistoryOrder: data};
		case SET_SCHEDULED_ORDERS:
			return {...state, scheduledOrders: data};
		case SET_ORDER_DRAWER_DATA:
	  return {...state, drawer: {...state.drawer, ...data}};
		case CLEAR_ORDER_DRAWER_DATA:
	  return {...state, drawer: initialState.drawer};
		case SET_PLATFORMS:
	  return {...state, platforms: data};
		case SET_BRANDS:
	  return {...state, brands: data};
		case SET_SYNCING_SAPU_SAPU:
			return {...state, syncingSapuSapu: data};
		default:
			return state;
	}
};

export default reducerOrder;
